<template>
  <card>
    <div class="d-flex justify-content-between align-items-center">
      <h4>{{ title }}</h4>
      <div v-if="isUnsavedChanges" class="unsaved-changes-label">
        Unsaved Changes
      </div>
    </div>
    <div class="d-flex flex-wrap mt-4" style="gap: 0.5rem">
      <!-- Full Name -->
      <div class="flex-fill" style="min-width: 45%; max-width: 48%">
        <input-text
          placeholder="What's Their full name?"
          :value="form.fullName"
          label="Full Name"
          id="employee-fullname"
          @change="handleChangeField('fullName', $event)"
          :error="errors.fullName"
          required
        />
      </div>

      <!-- Email -->
      <div class="flex-fill" style="min-width: 45%; max-width: 48%">
        <input-text
          placeholder="What's their work email address?"
          :value="form.email"
          label="Email"
          type="email"
          id="employee-email"
          @change="handleChangeField('email', $event)"
          :error="errors.email"
          required
        />
      </div>

      <!-- Phone Number -->
      <div class="flex-fill" style="min-width: 45%; max-width: 48%">
        <input-phone
          placeholder="What's a good contact number?"
          :value="form.phone"
          label="Phone Number"
          id="employee-phone"
          :error="errors.phone"
          @change="handleChangeField('phone', $event)"
          required
        />
      </div>

      <!-- Birth Date -->
      <div class="flex-fill" style="min-width: 45%; max-width: 48%">
        <input-date
          v-model="form.birthDate"
          label="Birth Date"
          placeholder="So, we don't miss their birthday!"
          :error="errors.birthDate"
          id="employee-birthdate"
          @change="handleChangeField('birthDate', $event)"
          required
        />
      </div>

      <!-- Type -->
      <div class="flex-fill" style="min-width: 45%; max-width: 48%">
        <single-select
          label="Type"
          :value="form.type"
          :options="[
            { label: 'Courier ', value: '3' },
            { label: 'Technician', value: '4' },
            { label: 'Internal', value: '5' },
          ]"
          placeholder="Choose an employment type"
          id="employee-type"
          :error="errors.type"
          @change="handleChangeField('type', $event)"
          required
        />
      </div>

      <!-- Join Date -->
      <div class="flex-fill" style="min-width: 45%; max-width: 48%">
        <input-date
          v-model="form.joinDate"
          label="Join Date"
          placeholder="When did they join?"
          :error="errors.joinDate"
          id="employee-joindate"
          @change="handleChangeField('joinDate', $event)"
          required
        />
      </div>

      <!-- Division -->
      <div class="flex-fill" style="min-width: 45%; max-width: 48%">
        <single-select
          label="Division"
          :value="form.division"
          :options="divisionOption"
          placeholder="Which team are they joining"
          id="employee-division"
          :error="errors.division"
          @change="handleChangeField('division', $event)"
          required
        />
      </div>

      <!-- Work Location -->
      <div class="flex-fill" style="min-width: 45%; max-width: 48%">
        <multi-select
          label="Work Location"
          :value="form.workLocation || []"
          :options="warehouseList"
          placeholder="Where do they work from?"
          id="employee-worklocation"
          :error="errors.workLocation"
          @change="handleChangeField('workLocation', $event)"
          required
        />
      </div>
    </div>
  </card>
</template>

<script>
import { InputText, InputPhone, InputDate, SingleSelect, MultiSelect } from "../../Input";
import { Card } from "../../Layout";

export default {
  name: "DetailData",
  components: {
    InputText,
    InputPhone,
    InputDate,
    SingleSelect,
    Card,
    MultiSelect
  },
  props: {
    errors: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Object,
      default: () => ({
        fullName: "",
        email: "",
        phone: "",
        birthDate: "",
        type: "",
        joinDate: "",
        division: "",
        workLocation: [],
      }),
    },
    isUnsavedChanges: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Employee Profile"
    }
  },
  data() {
    return {
      form: {
        fullName: "",
        email: "",
        phone: "",
        birthDate: "",
        type: "",
        joinDate: "",
        division: "",
        workLocation: "",
      },
      divisionOption: [],
      warehouseList: [],
      typeOptions: [
        { label: "Courier", value: "Courier" },
        { label: "Technician", value: "Technician" },
        { label: "Internal", value: "Internal" },
      ],
    };
  },
  methods: {
    async getDivision() {
      try {
        const response = await this.$http.get(
          process.env.GET_EMPLOYEE_DIVISION,
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        );
        if (response.data.status == 200) {
          this.divisionOption = response.data.content.map(el=> {
            return { label: el, value: el }
          });
        }
      } catch (error) {
        swal("Sorry", error.message, "error", {
          button: "Ok",
        }).then((v) => {
          if (error.response.data.status == 401) {
            this.handleLogout();
          }
        });
      }
    },
    async getWarehouseList() {
      try {
        const response = await this.$http.get(process.env.GET_CHILD_WAREHOUSE, {
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        });
        if (response.data.status == 200) {
          this.warehouseList = response.data.content.map((el) => {
            return { label: el, value: el };
          });
        }
      } catch (error) {
        swal("Sorry", error.message, "error", {
          button: "Ok",
        }).then((v) => {
          if (error.response.data.status == 401) {
            this.handleLogout();
          }
        });
      }
    },
    handleChangeField(key, value) {
      this.form[key] = value;
      this.$emit("change", this.form);
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.form = { ...val };
      }
    },
  },
  mounted() {
    this.getDivision();
    this.getWarehouseList();
    if (this.value) {
      this.form = { ...this.value };
    }
  },
};
</script>

<style scoped>
.unsaved-changes-label {
  background: #FFEDD5;
  padding: 2px 8px;
  color: #C2410C;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  width: fit-content;
}
</style>



// WEBPACK FOOTER //
// src/components/Employee/Components/DetailData.vue